// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tabs_wrapper__WWSmv","tab":"tabs_tab__rmhem"};